import { TopBar } from '@/layouts/TopBar';
import JobsList from '@jobs/components/JobsList';
import useJobs from '@jobs/hooks/useJobs';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const JobsPage = () => {
  const { t } = useTranslation();
  const { jobsCount } = useJobs();

  return (
    <>
      <TopBar title={t('JOBS')} count={jobsCount} />
      <Box m={2}>
        <JobsList />
      </Box>
    </>
  );
};

export default JobsPage;
